/* eslint-disable react-hooks/exhaustive-deps */
import { useAction } from "@corets/use-action"
import { useForm } from "@corets/use-form"
import { CircularProgress, FormHelperText } from "@mui/material"
import { useEffect } from "react"
import { useHistory, useParams } from "react-router"
import { links } from "../../../../../config/links"
import { WideDialog } from "../../../../oneportal/components/Dialogs/WideDialog"
import { createMuiFormBinder } from "../../../../oneportal/helpers/createMuiFormBinder"
import { useAlert } from "../../../../oneportal/hooks/useAlert"
import { useApiClient } from "../../../../oneportal/hooks/useApiClient"
import { getReflectionDetail } from "../../../services/api/reflectionSource"
import { createCreateOrUpdateReflectionSourceForm } from "./createCreateOrUpdateReflectionSourceForm"

export type CreateOrUpdateReflectionResourceDialogProps = {
  onSuccess: () => void
}

export const CreateOrUpdateReflectionResourceDialog = (props: CreateOrUpdateReflectionResourceDialogProps) => {
  const { onSuccess } = props
  const api = useApiClient()
  const alert = useAlert()
  const history = useHistory()

  const { reflectionSourceId } = useParams<{
    reflectionSourceId: string
  }>()

  const reflectionSourceDetail = useAction(async () => await getReflectionDetail(api, reflectionSourceId))

  const [form] = useForm(createCreateOrUpdateReflectionSourceForm(api, reflectionSourceDetail.getResult()?.content), [
    JSON.stringify(reflectionSourceDetail.getResult()?.content),
  ])

  const bind = createMuiFormBinder(form)

  console.log(reflectionSourceDetail.getResult()?.content)

  useEffect(() => {
    reflectionSourceId && reflectionSourceDetail.run()
  }, [reflectionSourceId])

  const handleSubmit = async () => {
    const errors = await form.validate()
    if (errors) return

    const res = await form.submit()

    if (res) {
      alert("Thành công", { variant: "success" })
      handleClose()
      onSuccess()
    } else {
      alert("Thất bại", { variant: "error" })
    }
  }

  const handleClose = () => history.push(links.category.reflectionSource())

  return (
    <WideDialog title={reflectionSourceId ? "Chỉnh sửa đơn vị xử lý" : "Thêm đơn vị xử lý"} onClose={handleClose}>
      <form>
        <div className="form-row">
          <div className="form-group col-12 col-md-12">
            <label>
              Tên nguồn phản ánh <span>*</span>
            </label>
            <input {...bind.textField("name")} />
            <FormHelperText {...bind.helperText("name")} />
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button
              disabled={form.isSubmitting() || !form.isChanged()}
              type="button"
              onClick={handleSubmit}
              className="btn btn-ct btn-primary-ct loading"
            >
              {form.isSubmitting() && <CircularProgress size={20} color="inherit" />}
              {reflectionSourceId ? "Lưu thay đổi" : "Thêm"}
            </button>
          </div>
        </div>
      </form>
    </WideDialog>
  )
}
